// ============================================
// ROLE DEFINITIONS
// ============================================

export const ROLES = {
  ADMIN: "Admin",
  SPOC: "Spoc",
  FINANCE: "Finance",
};

// Pages each role can access
export const ROLE_PAGES = {
  [ROLES.ADMIN]: [
    "dashboard",
    "create-new",
    "all-list",
    "renewal",
    "parent-code",
  ],
  [ROLES.SPOC]: ["dashboard", "create-new", "all-list"],
  [ROLES.FINANCE]: [
    "dashboard",
    "create-new",
    // "all-list",
    "Company-and-distributor",
  ],
};

// Granular permissions per role
// Admin   — full access: create, view, edit, update, approve, deficiency
// Spoc    — create + view all-list (view only, no edit/approve/deficiency)
// Finance — view all-list only (no create, no edit, no approve, no deficiency)
export const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: {
    canCreate: true,
    canEdit: true, // edit icon + editable modal fields
    canUpdate: true, // Update button
    canApprove: true, // Approve button
    canDeficiency: true, // Deficiency button
    canDelete: true,
    isReadOnly: false,
  },
  [ROLES.SPOC]: {
    canCreate: true, // can access create-new page
    canEdit: false, // no edit icon, no editable fields
    canUpdate: false,
    canApprove: false,
    canDeficiency: false,
    canDelete: false,
    isReadOnly: true, // modal is view-only
  },
  [ROLES.FINANCE]: {
    canCreate: false,
    canEdit: false,
    canUpdate: false,
    canApprove: false,
    canDeficiency: false,
    canDelete: false,
    isReadOnly: true, // modal is view-only
  },
};

const DEFAULT_PERMISSIONS = {
  canCreate: false,
  canEdit: false,
  canUpdate: false,
  canApprove: false,
  canDeficiency: false,
  canDelete: false,
  isReadOnly: true,
};

export const getPermissions = (role) =>
  ROLE_PERMISSIONS[role] || DEFAULT_PERMISSIONS;

export const canAccessPage = (role, page) =>
  (ROLE_PAGES[role] || []).includes(page);
